export default __webpack_public_path__ + "img/pin_icons/drinking_fountain_w.svg";